var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediumIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#FF0990"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77084 7.99097C8.77084 9.89741 7.23591 11.4429 5.34244 11.4429C3.449 11.4429 1.91406 9.89741 1.91406 7.99097C1.91406 6.08453 3.449 4.53906 5.34247 4.53906C7.23591 4.53906 8.77084 6.08453 8.77084 7.99097ZM12.5319 7.99097C12.5319 9.78556 11.7644 11.2403 10.8177 11.2403C9.87097 11.2403 9.1035 9.78556 9.1035 7.99097C9.1035 6.19638 9.87097 4.74159 10.8177 4.74159C11.7644 4.74159 12.5319 6.19638 12.5319 7.99097ZM14.0703 7.99097C14.0703 9.59884 13.8004 10.9023 13.4674 10.9023C13.1344 10.9023 12.8645 9.59884 12.8645 7.99097C12.8645 6.38309 13.1344 5.07966 13.4674 5.07966C13.8004 5.07966 14.0703 6.38309 14.0703 7.99097Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/medium-icon.c9857a197b20ce99112e2a178f0cf7bd.svg";
export { ForwardRef as ReactComponent };